import "./assets/table.css";
import "./assets/pagination.css";
import ModalVariousDocumentAdmin from "./components/ModalVariousDocumentAdmin";
import IconButton from "../../common/components/IconButton.jsx";
import Textfield from "../../common/components/Textfiled.jsx";
import { useState } from "react";
import { useVariousDocumentAdminlCommand } from "./hooks/useVariousDocumentAdminCommand";
import { useVariousDocumentAdminQuery } from "./hooks/useVariousDocumentAdminQuery";
import { FaFileDownload, FaTrash } from "react-icons/fa";
import { TYPES_DOCUMENTS } from "./constants/constants";
import Swal from "sweetalert2";
import Select from "../../common/components/Select";
import { DateUtil } from "../../common/utils/date.util.js";
import { BsClipboardPlus } from "react-icons/bs";

const TYPES_DOCUMENTS_MAP = TYPES_DOCUMENTS.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});

function VariousDocumentAdmin() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    decription: "",
  });
  const [isOpen, setIsOpen] = useState(false);
  const { documents, total, onChangePage, limit, page, refresh } =
    useVariousDocumentAdminQuery(filters);
  const {
    document,
    handleChange,
    createDocument,
    deleteDocument,
    setStateDefault,
    errors: { errors },
    loading: loadingCommand,
  } = useVariousDocumentAdminlCommand(refresh);

  const toggleModal = (document) => {
    setIsOpen((prev) => !prev);
    setStateDefault(document);
  };

  const onSubmit = () => {
    createDocument(document).then(() => {
      toggleModal();
    });
  };

  const handleDeleteDocument = (id) => {
    Swal.fire({
      title: "¿Estás seguro de eliminar el documento?",
      showDenyButton: true,
      confirmButtonText: `Eliminar`,
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteDocument(id);
      }
    });
  };

  const viewDocument = (url) => {
    window.open(url, "_blank");
  };

  const handleChangeFilters = ({ name, value }) => {
    console.log(name, value);
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <main className="container">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Documentos administrativos</h1>
        <div className="d-flex gap-2">
          <IconButton tooltipText="Registrar" onClick={toggleModal}>
            <BsClipboardPlus size={24} />
          </IconButton>
        </div>
      </header>

      <header className="d-flex justify-content-center align-items-center gap-3 mb-4 px-3 py-2 border-bottom flex-wrap flex-md-nowrap">
        <div className="d-flex gap-2">
          <Textfield
            name="startDate"
            label="Inicio"
            type="date"
            value={filters.startDate}
            onChange={handleChangeFilters}
          />
          <Textfield
            name="endDate"
            label="Fin"
            type="date"
            value={filters.endDate}
            onChange={handleChangeFilters}
          />
        </div>
        <Select
          name="description"
          label="Documentos"
          value={filters.description}
          onChange={handleChangeFilters}
          options={TYPES_DOCUMENTS}
        />
      </header>

      <section className="documents-section">
        <div className="documents-table-container">
          <table className="documents-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Descripción</th>
                <th>Observaciones</th>
                <th>Fecha</th>
                <th>Archivo</th>
              </tr>
            </thead>
            <tbody>
              {documents.map((document, index) => (
                <tr key={document.id}>
                  <td>{index + 1}</td>
                  <td>{TYPES_DOCUMENTS_MAP[document.description]}</td>
                  <td>{document.observations}</td>
                  <td>{DateUtil.format(document.createdAt)}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        gap: "0.3rem",
                      }}
                    >
                      <IconButton
                        onClick={() => viewDocument(document.file)}
                        className="download-button"
                      >
                        <FaFileDownload />
                      </IconButton>
                      <IconButton
                        onClick={() => handleDeleteDocument(document.id)}
                        className="delete-button"
                      >
                        <FaTrash />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ModalVariousDocumentAdmin
          isOpen={isOpen}
          onClose={toggleModal}
          onChange={handleChange}
          document={document}
          onSubmit={onSubmit}
          errors={errors}
          loading={loadingCommand}
        />
      </section>

      <footer>
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(total / limit)}
          onPageChange={onChangePage}
        />
      </footer>
    </main>
  );
}

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="pagination-container">
      <button
        className="pagination-button"
        onClick={handlePrevPage}
        disabled={currentPage === 1}
      >
        Anterior
      </button>

      <span className="pagination-info">
        Página {currentPage} de {totalPages}
      </span>

      <button
        className="pagination-button"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        Siguiente
      </button>
    </div>
  );
};

export default VariousDocumentAdmin;
